import { Stack } from '@mui/material';
import { toDateOrNull } from '../../../../../../utils/dates';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import { Catalog } from '../../../../catalog.types';
import CatalogAccessSection from './components/CatalogAccessSection/CatalogAccessSection';
import CatalogAutoInclusionSection from './components/CatalogAutoInclusionSection/CatalogAutoInclusionSection';
import CatalogDisplaySection from './components/CatalogDisplaySection/CatalogDisplaySection';
import CatalogGeneralInfoSection from './components/CatalogGeneralInfoSection/CatalogGeneralInfoSection';
import CatalogGridCriteriaSection from './components/CatalogGridCriteriaSection/CatalogGridCriteriaSection';
import CatalogNavigationSection from './components/CatalogNavigationSection/CatalogNavigationSection';

interface CatalogDetailsPanelProps {
  catalog: Catalog;
  isReadOnly: boolean;
}

const CatalogDetailsPanel = ({ catalog, isReadOnly }: CatalogDetailsPanelProps) => {
  const catalogDates = {
    startDate: toDateOrNull(catalog.startDate),
    endDate: toDateOrNull(catalog.endDate),
  };

  return (
    <Stack test-id={CatalogProductsTestIds.DETAILS_PANEL} sx={{ gap: 1.5 }}>
      <CatalogGeneralInfoSection
        id={catalog.id}
        name={catalog.name}
        code={catalog.code}
        isDefault={catalog.isDefault}
        isReadOnly={isReadOnly}
        isDynamic={catalog.isDynamic}
        active={catalog.active}
        startDate={catalog.startDate}
        endDate={catalog.endDate}
        enablePublicSharing={catalog.enablePublicSharing}
        liveLink={catalog.liveLink}
      />
      {catalog.isDynamic && (
        <>
          <CatalogAutoInclusionSection
            id={catalog.id}
            isReadOnly={isReadOnly}
            availability={catalog.availability}
            collections={catalog.collections}
            classifications={catalog.classifications}
            availabilityCriteriaOperator={catalog.availabilityCriteriaOperator}
            classificationCriteriaOperator={catalog.classificationCriteriaOperator}
          />
          <CatalogGridCriteriaSection
            id={catalog.id}
            isReadOnly={isReadOnly}
            availabilityConditions={catalog.availabilityConditions}
          />
        </>
      )}
      {!catalog.isDefault && (
        <CatalogDisplaySection
          id={catalog.id}
          isReadOnly={isReadOnly}
          navigationColorMode={catalog.navigationColorMode}
          groupColorsInSingleCard={catalog.groupColorsInSingleCard}
          showUnavailableProductsForSale={catalog.showUnavailableProductsForSale}
          withMedia={catalog.withMedia}
          isDynamic={catalog.isDynamic}
          navigationFilterRelatedProducts={catalog.navigationFilterRelatedProducts}
        />
      )}
      <CatalogAccessSection
        catalogId={catalog.id}
        isReadOnly={isReadOnly}
        catalogDates={catalogDates}
      />
      {!catalog.isDefault && (
        <CatalogNavigationSection
          id={catalog.id}
          isReadOnly={isReadOnly}
          navigationAvailabilities={catalog.navigationAvailabilities}
          navigationDeliveryWindows={catalog.navigationDeliveryWindows}
          showUnavailableProductsForSale={catalog.showUnavailableProductsForSale}
        />
      )}
    </Stack>
  );
};

export default CatalogDetailsPanel;
